import { render, staticRenderFns } from "./cooperateDialog.vue?vue&type=template&id=5ccab42b"
import script from "./cooperateDialog.vue?vue&type=script&lang=js"
export * from "./cooperateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports